import axios from 'axios';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { WalletState, Wallet, Transactions } from './types';
import { RootState } from '@/store/types';

const state: WalletState = {
  user_wallet: null,
  loadingWallet: false,
  loadingTransactions: false,
  transactions: null,
};

const mutations: MutationTree<WalletState> = {
  SET_WALLET(state: WalletState, wallet: Wallet) {
    state.user_wallet = wallet;
  },
  SET_LOADING_WALLET(state: WalletState, loadingWallet: Boolean) {
    state.loadingWallet = loadingWallet;
  },

  SET_TRANSACTIONS(state: WalletState, transactions: Transactions) {
    state.transactions = transactions;
  },
  SET_LOADING_TRANSACTIONS(state: WalletState, loadingTransactions: Boolean) {
    state.loadingTransactions = loadingTransactions;
  },
};

const getters: GetterTree<WalletState, RootState> = {
  wallet: (state: WalletState) => state.user_wallet,
  loadingWallet: (state: WalletState) => state.loadingWallet,
  transactions: (state: WalletState) => state.transactions,
  loadingTransactions: (state: WalletState) => state.loadingTransactions,
};

const actions: ActionTree<WalletState, RootState> = {

  fetchUserWallets({ commit, rootState, dispatch }: { commit: Function, rootState: any, dispatch: Function }) {
    if (!rootState.profile.mangoPayUser) {
      return null;
    }

    commit('SET_LOADING_WALLET', true);

    return axios.get(`${process.env.VUE_APP_EXPORO_WALLET_API_URL}/wallets`)
      .then(response => {
        commit('SET_WALLET', response.data);

        return Promise.resolve(response.data);
      })
      .catch(error => {
        commit('SET_WALLET', undefined);

        return Promise.reject(error.response);
      })
      .finally(() => commit('SET_LOADING_WALLET', false));
  },

  fetchTransactions({ commit }: { commit: Function }, { per_page = 25, page = 1, sort='creationdate:desc' } : { per_page?: number, page?: number, sort?:string}  ) {
    commit('SET_LOADING_TRANSACTIONS', true);
    commit('SET_TRANSACTIONS', undefined);

    return axios.get(`${process.env.VUE_APP_EXPORO_WALLET_API_URL}/transactions`, { params : { per_page, page, sort}})
      .then((resp) => {

        const transactions: Transactions = {
          data: resp.data,
          pagination: {
            totalItems: parseInt(resp.headers['x-number-of-items']),
            totalPages: parseInt(resp.headers['x-number-of-pages']),
            page,
            perPage: per_page,
          },
        };

        commit('SET_TRANSACTIONS', transactions);

        return Promise.resolve(resp.data);
      })
      .catch(error => {
        commit('SET_TRANSACTIONS', null);

        return Promise.reject(error.response);
      })
      .finally(() => commit('SET_LOADING_TRANSACTIONS', false));
  },

  createPayOut({ dispatch }: { dispatch: Function }, { amount, bankAccountId }: { amount: number, bankAccountId:string}) {
    const payload = {
      DebitedFunds: {
         Currency: 'EUR',
         Amount: amount,
      },
      Fees: {
         Currency: 'EUR',
         Amount: 0,
      },
      BankAccountId: bankAccountId,
      BankWireRef: 'Exporo withdraw',
    };

    return axios.post(`${process.env.VUE_APP_EXPORO_WALLET_API_URL}/pay-out`, payload)
    .finally( () => {
      dispatch('fetchUserWallets', {});
      dispatch('fetchTransactions', {});
    });
  },

  createPayIn({ dispatch }: { dispatch: Function }, { amount, statementDescriptor, mandateId  }: { amount: number, statementDescriptor: string, mandateId:string}) {
    const payload: any = {
      Amount: amount,
      MandateId: mandateId,
    };

    if (statementDescriptor) {
      payload.StatementDescriptor = statementDescriptor;
   }

    return axios.post(`${process.env.VUE_APP_EXPORO_WALLET_API_URL}/pay-in`, payload)
    .finally( () => {
      dispatch('fetchTransactions', {});
    });
  },

  fetchPayoutStatus({ commit, rootState }: { commit: Function, rootState: any }){
    return axios.get(`${process.env.VUE_APP_EXPORO_WALLET_API_URL}/user/{{userId}}/pay-out/{{payOutId}}`);
  },
};

export const wallet: Module<WalletState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
